/* eslint-disable eqeqeq */
import {
  Container,
  Link,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppBaseScreen from "../../components/AppBaseScreen";
import { theme, styles } from "./theme";
import { LinearProgress } from "@mui/material";

import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS, paymentOptions } from "../../utils/constants";
import {
  formatNumber,
  isBlockedUser,
} from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import KycPending from "./components/KycPending";
import KycBlocked from "./components/KycBlocked";
import config, { ONBOARDING_GUIDE_LINK } from "../../utils/config";
import KyconHold from "./components/KyconHold";
import { getDashboardData } from "../../store/actions";
import Step1 from "./components/common-steps/Step1";
import Step2 from "./components/common-steps/Step2";
import RenderSteps from "./components/withdraw-options/render";
import { logEvent } from "../../store/api";
import { isIOS } from "react-device-detect";

const Withdraw = () => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({
    address: "",
    amount: "",
  });
  const { t } = useTranslation();
  const dashboardData = useSelector(({ dashboard }) => dashboard);
  const skip = useSelector(({ transfer }) => transfer.skip);
  const user = useSelector(({ Auth }) => Auth.user);
  const [active, setActive] = useState(0);
  const [amount, setAmount] = useState("");
  const [payment, setPayment] = useState("");
  const navigate = useNavigate();
  const [showKyt, setShowKyt] = useState(false);
  const [showKytBlocked, setShowKytBlocked] = useState(false);
  const [showKycReview, setShowKycReview] = useState(false);
  const [caluclate, setCalculate] = useState(25);
  const location = useLocation();
  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (user && user.kycStatus) {
      // eslint-disable-next-line eqeqeq
      if (user && user.kycStatus && isBlockedUser(user.kycStatus)) {
        setShowKytBlocked(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus == 4
      ) {
        setShowKycReview(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus != 2
      ) {
        setShowKyt(true);
      }
    }
    // get data
    dispatch(getDashboardData());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let query = '';
    if (payment) query = `/${payment}`
    navigate(`/withdraw/${active}${query}`);
    //for crypto
    if (active === 3 && payment === paymentOptions.crypto && user && user.kycStatus) {
      // eslint-disable-next-line eqeqeq
      if (isBlockedUser(user.kycStatus)) {
        setShowKytBlocked(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus == 4
      ) {
        setShowKycReview(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus != 2
      ) {
        setShowKyt(true);
      }
    }
    // for non crypto
    if (active === 2 && payment === paymentOptions.nonCrypto && user && user.kycStatus) {
      // eslint-disable-next-line eqeqeq
      if (isBlockedUser(user.kycStatus)) {
        setShowKytBlocked(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus == 4
      ) {
        setShowKycReview(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus != 2
      ) {
        setShowKyt(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);


  const getSubs = (active) => {
    switch (active) {
      case 0:
        return `${t("selectAmount")}`;
      case 1:
        return `${t("selectPayment")}`;
      case 2:
        if (payment === paymentOptions.crypto)
          return `${t("selectCurrency")}`;
        else
          return t("Select country");
      case 3:
        if (payment === paymentOptions.crypto)
          return `${t("addWallet")}`;
        else
          return t("Transfer options");
      case 4:
        if (payment === paymentOptions.crypto) return;
        else return t("Transfer options");
      case 5:
        if (payment === paymentOptions.crypto) return;
        else return t("selectCurrency");
      case 6:
        if (payment === paymentOptions.crypto) return;
        else return t("Fill the form");
      case 7:
        if (payment === paymentOptions.crypto) return;
        else return t("Summary")
      default:
        return "";
    }
  };



  const getBackTitles = (active) => {
    const constant = active;
    if (skip.includes(active)) {
      active = active - 1;
    }
    if (skip.includes(active) && constant === 4) {
      active = active - 1;
    }

    switch (active) {
      case 0:
        return `${t("selectAmountBack")}`;
      case 1:
        return `${t("selectPaymentBack")}`;
      case 2:
        if (payment === paymentOptions.crypto)
          return `${t("selectCurrencyBack")}`;
        else
          return t("Select country");
      case 3:
        if (payment === paymentOptions.crypto)
          return `${t("addWalletBack")}`;
        else
          return t("Transfer options");
      case 4:
        if (payment === paymentOptions.crypto) return;
        else return t("Transfer options");
      case 5:
        if (payment === paymentOptions.crypto) return;
        else return t("Select currency");
      case 6:
        if (payment === paymentOptions.crypto) return;
        else return t("Fill the form back");
      case 7:
        if (payment === paymentOptions.crypto) return;
        else return t("Summary")
      default:
        return "";
    }
  };
  const handlePaymentMethod = (ev, value) => {
    ev.preventDefault();
    setPayment(value);
    if (value === paymentOptions.nonCrypto) {
      setCalculate(100 / 6);
    } else {
      setCalculate(25);
    }
    logEvent({
      current: EVENTS.WITHDRAWAL.TRANSFER_METHOD,
      activity: ACTIVITY_DETAIL.WITHDRAWAL.TRANSFER_METHOD,
      meta: {
        data: {
          method: value.toLowerCase() === paymentOptions.crypto.toLowerCase() ? paymentOptions.crypto.toUpperCase() : paymentOptions.nonCrypto.toUpperCase(),
          pathname: location.pathname,
          source: ACTIVITY_META.WITHDRAWAL.TRANSFER_METHOD
        }
      }
    });
    setActive(active + 1);
  };

  const handleAmountChange = (val, err) => {
    setAmount(val.toString());
    setErrors({ ...errors, ...err });
  };



  const handleVerification = () => {
    setShowKyt(false);
    navigate("/verification");
  };

  const handleActive = (active) => {
    if (active === 1) {
      if (amount <= 0) {
        setErrors({ amount: t("invalidAmount") });
        return;
      }

      if (
        parseFloat(amount.toString()) >
        parseFloat(dashboardData.balance.toString())
      ) {
        setErrors({
          amount:
            "Amount should be lower than or equal to the available balance",
        });
        return;
      }
      if (parseFloat(amount.toString()) < config.MIN_WITHDRAWL_AMOUNT) {
        setErrors({ amount: `${t('AmountEqual')} $${config.MIN_WITHDRAWL_AMOUNT}` });
        return;
      }
      logEvent({
        current: EVENTS.WITHDRAWAL.TRANSFER_BEGIN,
        activity: ACTIVITY_DETAIL.WITHDRAWAL.TRANSFER_BEGIN,
        meta: {
          data: {
            amount: amount,
            max: Number(amount) === Number(dashboardData.balance),
            pathname: location.pathname,
            source: ACTIVITY_META.WITHDRAWAL.TRANSFER_BEGIN
          }
        }
      });
    }

    setActive(active);
  }

  const handleSetActive = () => {
    let tab = active - 1;
    while (skip.includes(tab)) {
      tab = tab - 1;
    }

    setActive(tab)
  }

  return (
    <AppBaseScreen
      headerTitle1={t("homePage.withdraw")}
      headerSubTitle1={getSubs(active)}
      navigate={true}
      navigatePath={!active ? "/home" : handleSetActive}
      cancel={() => navigate("/home")}
      backText={!active ? "Home" : getBackTitles(active - 1)}
    >
      <KycPending
        active={active}
        handleVerification={handleVerification}
        setShowKyt={setShowKyt}
        showKyt={showKyt}
        payment={payment}
      />
      <KycBlocked
        handleVerification={handleVerification}
        setShowKytBlocked={setShowKytBlocked}
        showKytBlocked={showKytBlocked}
      />
      <KyconHold setShowKyt={setShowKycReview} showKyt={showKycReview} />
      <ThemeProvider theme={theme}>
        <Container maxWidth="xs" disableGutters>
          <LinearProgress variant="determinate" value={caluclate * active} />
          {active === 0 && (
            <Step1 active={active} amount={amount} dashboardData={dashboardData} errors={errors} handleActive={handleActive} handleAmountChange={handleAmountChange} />
          )}

          {active === 1 && (
            <Step2 handlePaymentMethod={handlePaymentMethod} payment={payment} paymentOptions={paymentOptions} styles={styles} />
          )}

          <RenderSteps active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKycReview} type={payment} />

          {(payment === paymentOptions.crypto ? [1, 2] : [1, 2, 3]).includes(active) && (
            <Box sx={{ height: "10vh", position: "fixed", bottom: isIOS ? '4%' : 1 }}>
              <Typography color={"#D4D4D8"} fontWeight={400} fontSize={30}>
                $ {formatNumber(amount)}
              </Typography>
              <Link
                href={ONBOARDING_GUIDE_LINK + "/fee-schedule"}
                target="_blank"
                color={"#0088F5"}
                fontSize={16}
                fontWeight={500}
              >
                {t("Learn more about fees")}
              </Link>
            </Box>
          )}

        </Container>
      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default Withdraw;
